/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */


import { CircularProgress, Paper, TableContainer } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

import { Link } from "react-router-dom";
import VolunteerFilterNoAdd from "../../components/Others/VolunteerFilterNoAdd";
import Pagination from "../../components/table-components/pagination/Pagination";
import TableComp from "../../components/table-components/table/TableComp";
import useGetAllTrialsList from "../../hooks/useGetAllTrialsList";

const CurrentTrialList = ({ user }) => {
  const [filterTrialList, setFilterTrialList] = useState([]);

  const [getAllTrialsList, isLoading, isError, error, isSuccess, refetch] =
    useGetAllTrialsList();

  useEffect(() => {
    if (getAllTrialsList) {
      const filteredData = getAllTrialsList.filter(
        (trialList) => trialList?.active_flag === "1"
      );
      setFilterTrialList(filteredData);
    }
  }, [getAllTrialsList]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Trial Name",
        accessor: "trial_name",
        Filter: false,
      },

      {
        Header: "Action",
        Filter: false,
        Cell: ({ row }) => (
          <Link
            style={{
              color: "#007bff",
              textDecoration: "none",
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
            to={`/trial/${row.original.trial_id}`}
          >
            Go To
          </Link>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: filterTrialList || [] },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const { globalFilter } = state;
  const { pageIndex } = state;
  return (
    <>
      {/* search bar */}
      <div>
        <VolunteerFilterNoAdd
          filter={globalFilter}
          setFilter={setGlobalFilter}
        />
      </div>

      {/* table */}
      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
    </>
  );
};

export default CurrentTrialList;
